import React from 'react'
import { getFormatDate, outputMoney } from '@/public/utils'
import { Popover, Space, Popconfirm,Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import _, { get } from 'lodash'
import { getFormatDateIsNull } from '../common/utils'

export const signTypeOptions = [{ label: '电子', value: '00' }, { label: '实物', value: '01' }]
export const signTypeMap = { '00': '电子', '01': '实物' }
export const dateTypeOptions = [{ label: '创建时间', value: 1 }, { label: '审核时间', value: 2 }]
export const StatusColorMap = { "00": "#bfbfbf", "01": "#0e77d1", "02": "#00a854", "03": "#f04134", "04": "#ffbf00", "05": "#bfbfbf" }
const editRules = ['00', '04']


export const getColumns = (data = {}) => {
  const { enums, cancellation,sigoCompanys } = data
  var columns = [
    {
      title: '票单关联号',
      key: 'match_id',
      dataIndex: 'match_id',
      width: 130,
      fixed: 'left',
      align: 'center',
      render: (text) => {
        return <Link to={`/main/bill/match/detail?match_id=${text}`}>{text}</Link>
      }
    },
    {
      title: '发票含税金额',
      key: 'invoice_amount',
      align: 'center',
      dataIndex: 'invoice_amount',
      render: (text) => <div style={{ textAlign: "right" }}>{outputMoney(text)}</div>
    },
    {
      title: '发票数量',
      key: 'invoice_num',
      dataIndex: 'invoice_num',
      width: 90,
      align: 'center',
    },
    {
      title: '对账单号',
      align: 'center',
      width: 130,
      key: 'account_list',
      dataIndex: 'account_list',
      render: (text, record) => {
        var data = get(record, 'account_list') || []
        if (get(data, 'length') < 1) return '--'
        if (get(data, 'length') > 0) {
          return <Popover content={<div>
            {(data || []).map(el =>
              <a href={`/main/supplierRecantion/listDetails?code=${get(el, 'account_no')}`} target={'_blank'}>
                {get(el, 'account_no')} </a>
            )}
          </div>}>
            <a href={`/main/supplierRecantion/listDetails?code=${get(data, '0.account_no')}`} target={'_blank'}>
              {get(data, '0.account_no')} </a>
          </Popover>
        }
      }
    },
    {
      title: '对账单金额',
      align: 'center',
      key: 'account_amount',
      dataIndex: 'account_amount',
      render: (text) => <div style={{ textAlign: "right" }}>{outputMoney(text)}</div>
    },
    {
      title: '税票差异调整金额',
      align: 'center',
      dataIndex: 'adjust_amount',
      width: '8%',
      width: 150,
      key: 'adjust_amount',
      render: (text) => <div style={{ textAlign: "right" }}>{outputMoney(text)}</div>
    },
    {
      title: '单据状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: 140,
      render: (text,record) => text !== '--' && <div>
        {
          get(record, 'status') == '03' ?
            <Tooltip title={ `退回快递：${(record['back_company_name'])} ${(record['back_send_code'])}；退回原因：${(get(record, 'back_reason') || '')} `}>
              <span style={{
                display: 'inline-block', width: 6, height: 6, marginRight: 4, borderRadius: '50%', backgroundColor:
                  StatusColorMap[text]
              }} />{(get(enums, '匹配单状态枚举值')||{})[text] || '-'}
            </Tooltip>
            : <span><span style={{
              display: 'inline-block', width: 6, height: 6, marginRight: 4, borderRadius: '50%', backgroundColor:
                StatusColorMap[text]
            }} />{(get(enums, '匹配单状态枚举值')||{})[text] || '-'}</span>
}

      </div>
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 150,
      align: 'center',
      render: (text, record) => `${getFormatDateIsNull(record['create_time'],'YYYY-MM-DD hh:mm:ss')}`
    },
    {
      title: '视客审核时间',
      dataIndex: 'audit_time',
      key: 'audit_time',
      width: 150,
      align: 'center',
      render: (text, record) => `${getFormatDateIsNull(record['audit_time'],'YYYY-MM-DD hh:mm:ss')}`
    },
    {
      title: '操作',
      dataIndex: 'operate',
      key: 'operate',
      width: 100,
      fixed: 'center',
      render: (text, record) => {
        if (editRules.includes(record.status)) {
          return <Space>
            <Link to={`/main/bill/match/detail?match_id=${record['match_id']}`}>编辑</Link>
            <Popconfirm
              title="你确定要作废吗?"
              onConfirm={() => cancellation(record)}
              okText="确定"
              cancelText="取消"
            >
              <a>作废</a>
            </Popconfirm>
          </Space>
        }
        return ''
      }
    }
  ]

  if (get(sigoCompanys,'length')>1) {
    var item = {
      title: '结算主体',
      align: 'center',
      key: 'buyer_no',
      width: '14%',
      dataIndex: 'buyer_no',
      render: (text, record) => `${get(record, 'buyer_name') || '--'}`
    }
    columns.splice(1,0,item)
  }
  return columns
}


export const getSearchTabs = (data = {
}) => {
  return [
    {
      label: `全部 (${(get(data,'total_num') || 0)})`,
      key: 'all'
    }, {
      label: `待视客审核 (${(get(data,'status1_num') || 0)})`,
      key: '01'
    }, {
      label: `视客审核通过 (${(get(data,'status2_num') || 0)})`,
      key: '02'
    }, {
      label: `视客审核拒绝 (${(get(data,'status3_num') || 0)})`,
      key: '03'
    }, {
      label: `返回修改 (${(get(data,'status4_num') || 0)})`,
      key: '04'
    }, {
      label: `草稿 (${(get(data,'status0_num') || 0)})`,
      key: '00'
    },
    {
      label: `已作废 (${(get(data,'status5_num') || 0)})`,
      key: '05'
    }
  ]
}





// WEBPACK FOOTER //
// ./src/pages/billVerification/match/list/config.js